/* ─────────────────────────────────────────────────────────────
   PB-CART-DRAWER
───────────────────────────────────────────────────────────────*/


// ── Format money ───────────────────────────────────────────
/*  Also called by delivery-lookup.js, so the address figure and the drawer's own money
    cannot be formatted two different ways. Global by declaration; both scripts are
    deferred and nothing calls this on load. */
function pcdFormatMoney(cents) {
    const dollars = cents / 100;
    return '$' + (cents === 0 ? dollars.toFixed(2) : (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2)));
}

// ── Format date DMY ────────────────────────────────────────
/*  NOW UNUSED — the subtitle it formatted is rendered by Liquid as of dev-build 76.
    Left in place deliberately: deleting it inside a patch about the render path is the
    unrelated edit that makes a delivery hard to review. Logged for #114, the lint pass. */
function pcdFormatDate(iso) {
    /*  Was its own copy of the month list, with "Sep" where the booking bar directly
        above it said "Sept". One list, in charged-nights.js.

        It also parsed a date-only string with new Date(iso) — UTC midnight — and then
        read LOCAL parts, which is a day early anywhere west of UTC. The shared
        formatter anchors at midday. */
    return window.formatBookingDate ? window.formatBookingDate(iso) : '';
}

// ── Position drawer under pill (desktop only) ──────────────
function pcdPosition() {
    if (window.innerWidth < 768) return;
    const pill    = document.getElementById('pb-cart-drawer-toggle');
    const drawer  = document.querySelector('.pb-cart-drawer-sidebar');
    const wrapper = document.querySelector('.pb-cart-drawer-container');
    if (!pill || !wrapper) return;
    const rect = pill.getBoundingClientRect();
}

// ── Open drawer ────────────────────────────────────────────
/* ── Show the drawer with no network at all ─────────────────────────────────────
   Split out of openCartDrawer so a caller can put the panel on screen the instant a
   button is pressed, and let the data catch up.

   Add-to-cart needs this. It runs /cart/add.js, then /cart/update.js for the booking
   attributes, and only then calls openCartDrawer — which fetches /cart.js itself. Three
   sequential round-trips before anything appears. Tolerable on office wifi, useless on
   3G, where the customer taps Add and watches an unchanged page.

   On a first-ever add the drawer has never been filled, so it would open empty. The
   placeholder below covers that one case and is overwritten the moment data lands. */
/*  The moment the drawer last opened.

    The click that OPENS the drawer keeps bubbling to the document-level outside-click
    handler below, where it is by definition a click outside the drawer. Without a
    guard, the drawer opens and closes on the same click. */
let pcdOpenedAt = 0;
/*  382: set when the customer closes the drawer while it is still loading. The open
    already in flight (add-to-cart calls openCartDrawer after its round-trips) then
    refreshes the contents without putting the drawer back on screen. A tap on the
    header toggle clears it, so a deliberate reopen always works. */
let pcdSuppress = false;
/* #63 — the cart token as of the last successful drawer render, and the token the
   current open is drawing towards. Equal means the rows on screen are still right. */
let pcdLastToken = null;
let pcdPendingToken = null;

function showCartDrawer() {
    const drawer = document.querySelector('.pb-cart-drawer');
    if (!drawer) return;

    /*  ── SHOW THAT SOMETHING IS COMING ──────────────────────────────────────────
        On a second add the drawer already holds items, so dimming them (.is-pending)
        is enough — the customer can see what is there and that it is about to change.

        On a FIRST add there is nothing to dim. The panel opened as an empty white box
        with no indication it was loading, which is arguably worse than the old delay:
        at least a delay eventually produced something, where an empty box reads as
        "your booking is empty".

        So when the body holds no real items, fill it with a skeleton of the row that
        is about to appear. Nothing to clean up: as of dev-build 76 the whole sidebar is
        replaced by the section render, which takes the skeleton with it.

        A skeleton rather than a spinner, deliberately. It occupies the shape the
        content will take, so the panel does not jump when the data lands, and a
        spinner that flashes for 200ms on a fast connection reads as an error. */
    /* ── #63: SKELETON ONLY WHEN THE CART ACTUALLY CHANGED — 11-09-2026 ──────────

       The test used to be "does the body hold no items yet", and closeCartDrawer()
       never clears the body. So the skeleton appeared on the FIRST open of a page load
       and never again: every reopen showed the previous rows dimmed to 0.4 by
       .is-pending instead. Both states were built deliberately — the dip at
       pb-cart-drawer.css:207, the skeleton here — but which one won on reopen was
       never decided, and it looked like a regression.

       Decided: skeleton when the cart has changed since we last drew it, dimmed real
       rows when it has not. Real content dimmed is more informative than grey blocks
       while the content is still accurate; grey blocks are right when it is not.

       pcdLastToken is the cart token as of the last successful render. Shopify issues a
       new token on every mutation, so an unchanged token means the rows on screen are
       still correct. Held in a module variable, not sessionStorage — it should reset on
       navigation, because a fresh page load has drawn nothing yet.

       Unknown token (first open, or a fetch that has not landed) falls to the skeleton:
       showing a skeleton over correct rows costs a moment of grey, while dimming stale
       rows shows a wrong price as though it were merely loading. */
    const bodyEl = drawer.querySelector('.pb-cart-drawer-body');
    const cartChanged = !pcdLastToken || pcdLastToken !== pcdPendingToken;
    if (bodyEl && (cartChanged || !bodyEl.querySelector('.pb-cart-drawer-item'))) {
        bodyEl.innerHTML =
            '<div class="pb-cart-drawer-skeleton" aria-hidden="true">' +
            '  <div class="pb-cart-drawer-skeleton-row">' +
            '    <div class="pcd-sk pcd-sk-img"></div>' +
            '    <div class="pcd-sk-lines">' +
            '      <div class="pcd-sk pcd-sk-line pcd-sk-line-wide"></div>' +
            '      <div class="pcd-sk pcd-sk-line pcd-sk-line-narrow"></div>' +
            '    </div>' +
            '  </div>' +
            '</div>' +
            '<span class="pb-cart-drawer-loading-label" role="status">Updating your booking</span>';
    }

    /* ── #71: "Adding to your booking" is gone from the drawer — 11-09-2026 ───────
       Two places said it: this heading, set while the fetch was in flight, and the
       label under the skeleton. The heading then became "Your booking" the moment the
       render landed, so the customer read one thing and then another for no reason —
       and the decision that the drawer does not need a stated heading was already
       taken (see the Heading block in the render, which deliberately states no count).

       The heading is now set to its final wording up front, so it does not change
       under the reader. The skeleton is what says "loading"; it occupies the shape the
       row will take, which a heading cannot.

       The label survives as screen-reader-only text, because a skeleton is
       aria-hidden and a non-sighted user would otherwise get silence. Its wording is
       "Updating your booking" — true on a first add and on a change alike. */
    const titleEl = drawer.querySelector('.pb-cart-drawer-title');
    if (titleEl && !titleEl.textContent.trim()) {
        titleEl.textContent = 'Your booking';
    }

    pcdPosition();
    drawer.classList.add('is-active', 'is-pending', 'is-loading');

    /* When it opened. Read by the outside-click handler — see the note there. */
    pcdOpenedAt = Date.now();
}

/*  delivery-lookup.js is a separate asset, so it may be absent on a theme where only
    some of the files were installed. Guarded once here rather than at each call site. */
function pcdWireDelivery(drawer) {
    if (window.DJWDelivery && typeof window.DJWDelivery.wire === 'function') {
        /*  drawer, not document: wire() scans for [data-de-scope] under whatever it is
            given, and scoping it to the drawer keeps this call from re-walking the cart
            page's own scope on every drawer open. wireScope marks what it handles, so
            passing document would be harmless — just wasteful. */
        window.DJWDelivery.wire(drawer);
    }
}

async function openCartDrawer() {
    const quiet = pcdSuppress;
    pcdSuppress = false;
    /* 296: hide the chat button on the tap, before anything moves (pb-cart-drawer.css). */
    if (!quiet) document.documentElement.classList.add('pcd-open');
    const drawer = document.querySelector('.pb-cart-drawer');
    if (!drawer) return;

    /* ── Show it NOW, fill it in a moment ───────────────────────────────────
       This function used to await /cart.js before adding .is-active, so nothing
       happened on screen until the round-trip came back. On a slow connection the
       customer taps, sees nothing, and taps again — which is what "the drawer is
       delayed" was.

       Opening first costs nothing: the drawer already holds the previous render, so
       the customer sees their booking immediately and the numbers settle a moment
       later. A pending class lets the CSS soften that if we want it to.

       The auto-dismiss timer is started AFTER the fill, not here, so a slow cart can
       never eat into the six seconds the customer has to read it. */
    if (!quiet) showCartDrawer();

    /*  527: the cart and the drawer HTML are fetched together (they ran one after the
        other — the note below said parallel, the code was not). And if a copy of the
        drawer was prepared since the cart last changed, it goes in straight away, so
        availability and prices show the moment the drawer opens. */
    const htmlP = fetch('/?section_id=pb-cart-drawer-body').then(r => r.ok ? r.text() : null).catch(() => null);
    const hostNow = drawer.querySelector('[data-drawer-content]');
    /*  543: opened while a change is under way — skeleton everything, draw nothing yet.
        The single refresh when the change finishes (djw:cart) fills it in. Before, the
        ready-made copy and this open's own fetch both drew the half-changed cart. */
    if (document.documentElement.classList.contains('djw-cart-busy')) {
        drawer.classList.add('is-repricing');
        drawer.classList.remove('is-pending', 'is-loading');
        pcdShownV = -1;
        pcdHoldSkeleton();
        return;
    }
    if (pcdWarm.html && pcdWarm.v === pcdVersion() && hostNow) {
        pcdKeepScroll(hostNow, function () { hostNow.innerHTML = pcdWarm.html; });
        if (window.DJWBlackout && window.DJWBlackout.markDrawer) window.DJWBlackout.markDrawer(hostNow);
        pcdWireDelivery(drawer);
        drawer.classList.remove('is-pending', 'is-loading');
    }
    const cart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
    /*  543: same rule as the refresh — a cart whose lines don't match the nights yet, or
        a change that started while we were fetching, is not drawn. */
    if (document.documentElement.classList.contains('djw-cart-busy') || (cart && window.cartStore && window.cartStore.consistent && !window.cartStore.consistent(cart))) {
        drawer.classList.add('is-repricing');
        drawer.classList.remove('is-pending', 'is-loading');
        pcdShownV = -1;
        clearTimeout(pcdWaitTimer); pcdWaitTimer = setTimeout(pcdQueueRefresh, 1500);
        pcdHoldSkeleton();
        return;
    }

    drawer.classList.remove('is-pending');

    if (!cart) {
        drawer.classList.remove('is-loading');
        /* Leave the drawer open showing the last known state rather than closing it
           under the customer — a failed fetch is not a reason to undo their tap. */
        return;
    }

    /* #63 — this render is now the truth on screen, so remember which cart it drew.
       Set before the rows are built rather than after, so an exception mid-render does
       not leave a stale token claiming the rows are current. */
    pcdLastToken = cart.token || null;
    pcdPendingToken = pcdLastToken;

    /* ── #26: the rows are rendered by Liquid now, not built here ──────────────
       Everything that stood here assembled the heading, the subtitle and every row
       in JavaScript from /cart.js. That was the drift: two implementations of a gear
       row, and nine of the defects closed on this project were the two disagreeing.

       Now the drawer asks the server for its own content — the same
       pb-cart-drawer-inner snippet it rendered inline on first paint, re-rendered
       through the section endpoint. One source, so the drawer cannot disagree with
       the cart page about options, availability, price or nights.

       /cart.js is still fetched, in PARALLEL above rather than in sequence, purely
       for cart.token. The token drives the skeleton-versus-dim decision in
       showCartDrawer and Liquid has no equivalent — cart.token is not exposed to it.
       So this costs no latency over the single fetch it replaces. */
    const html = await htmlP;
    if (html) { pcdWarm = { html: html, v: pcdVersion() }; pcdShownV = pcdVersion(); }

    drawer.classList.remove('is-loading');
    if (!html) {
        /* Same reasoning as the cart.js failure above: leave what is on screen. A
           failed re-render is not a reason to blank a drawer the customer opened. */
        return;
    }

    pcdLastToken = cart.token || null;
    pcdPendingToken = pcdLastToken;

    const host = drawer.querySelector('[data-drawer-content]');
    if (host) {
        pcdKeepScroll(host, function () { host.innerHTML = html; });
        /*  dev-build 206 — real availability on every row (DJWBlackout.markDrawer). */
        if (window.DJWBlackout && window.DJWBlackout.markDrawer) window.DJWBlackout.markDrawer(host);

        /* ── Re-wire what the swap discarded ──────────────────────────────────
           innerHTML destroys every listener inside it. Keep browsing and the
           address field both live in there, so both are re-attached.

           What does NOT need re-attaching, and why: the overlay, the outside-click
           guard, Escape and the header toggle are all bound to document or to
           elements outside the swapped region. */
        host.querySelector('.pb-cart-drawer-browsing-btn')
            ?.addEventListener('click', closeCartDrawer);

        /* An <a> cannot be natively disabled, and swapping it for a <button> would
           lose middle-click and right-click. So the empty state marks it and the
           click is refused here. */
        host.querySelector('.pb-cart-drawer-booking-btn.is-disabled')
            ?.addEventListener('click', function (ev) { ev.preventDefault(); });

        pcdWireDelivery(drawer);
    }

    /* cart.item_count, NOT cart.items.length.

       items.length counts LINES; item_count counts UNITS. Sixteen uplights added as one
       line is items.length === 1 and item_count === 16. The pill read "1" next to a
       drawer listing sixteen lights.

       The Liquid that renders this on page load has the same fault — header-actions
       uses {{ cart.items | size }} — so it is corrected there too. Both must agree, or
       the number changes the moment the drawer opens. */
    const countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(el => { el.textContent = cart.item_count; });

}

// ── Close drawer ───────────────────────────────────────────
function closeCartDrawer() {
    document.documentElement.classList.remove('pcd-open');
    const drawer = document.querySelector('.pb-cart-drawer');
    if (drawer && drawer.classList.contains('is-loading')) pcdSuppress = true;
    if (drawer) drawer.classList.remove('is-active', 'is-pending', 'is-loading');
}

// ── Init ───────────────────────────────────────────────────
function initCartDrawer() {
    const drawer  = document.querySelector('.pb-cart-drawer');
    const overlay = document.querySelector('.pb-cart-drawer-overlay');
    if (!drawer) return;

    // ── Overlay click ──────────────────────────────────────
    if (overlay) overlay.addEventListener('click', closeCartDrawer);

    /* ── Clicking anywhere outside the drawer closes it ─────────────────────
       The overlay listener above was the only way to dismiss by clicking away, and it
       only fires where the overlay actually sits under the pointer. Anywhere the
       overlay does not cover — or if it sits behind the page in the stacking order —
       the click did nothing and the drawer stayed put.

       Bound to document instead, so it works regardless of what the overlay covers.

       The toggle check matters: the click that OPENS the drawer also reaches this
       handler, and it is by definition outside the drawer. Without the guard the
       drawer would open and close on the same click. */
    document.addEventListener('click', function (e) {
        const liveDrawer = document.querySelector('.pb-cart-drawer');
        if (!liveDrawer || !liveDrawer.classList.contains('is-active')) return;

        if (e.target.closest('.pb-cart-drawer-sidebar')) return;   // inside it
        /*  382: the delivery estimate popup is moved to <body>, so every click in it is
            "outside" the sidebar. Clicks in it, its address suggestions, or while it is
            open must never close the drawer. */
        if (document.documentElement.classList.contains('d5-modal-open')) return;
        if (e.target.closest('[data-d6-modal], [data-d5-modal], .pac-container, .dj-addr-suggest')) return;

        /*  ── THE OPENING CLICK MUST NOT CLOSE IT ────────────────────────────────
            This used to be a list of opener selectors: #pb-cart-drawer-toggle,
            [data-cart-drawer-toggle], .mm-booking. That covered the header, and only
            the header.

            Then add-to-cart on the product page became an opener too, and
            .pp-booking-card-btn was not on the list. So every add opened the drawer
            and closed it again on the same click — and the drawer the customer
            eventually saw was the one openCartDrawer() re-opened once the two network
            round-trips had finished.

            Which meant "the drawer opens the instant you tap" was silently defeated
            from the moment it shipped. Measured on the beta: .is-active applied at
            2ms, gone again by 120ms, back at ~1.6s.

            A selector list is the wrong shape for this — it needs updating every time
            anything new opens the drawer, and forgetting is silent. A time guard is
            immune to that: no click within 300ms of opening can be a deliberate
            dismissal, and the same-click bubble is ~0ms.

            The selector list stays as well, now including the booking card button. It
            costs nothing and reads as documentation of what opens this thing. */
        if (Date.now() - pcdOpenedAt < 300) return;
        if (e.target.closest('#pb-cart-drawer-toggle, [data-cart-drawer-toggle], .mm-booking, .pp-booking-card-btn')) return;

        closeCartDrawer();
    });

    /* Escape closes it too. Added because the drawer no longer dismisses itself — with
       the timer gone, a customer whose click-away misses has no way out but a reload.
       Say the word and I'll drop it. */
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        const liveDrawer = document.querySelector('.pb-cart-drawer');
        if (document.documentElement.classList.contains('d5-modal-open')) return;   // 382: Escape closes the popup first
        if (liveDrawer && liveDrawer.classList.contains('is-active')) closeCartDrawer();
    });

    // ── Keep browsing ──────────────────────────────────────
    drawer.querySelector('.pb-cart-drawer-browsing-btn')
        ?.addEventListener('click', closeCartDrawer);

    /* ── Toggle click ───────────────────────────────────────────────────────
       Delegated from document, and matching BOTH toggles.

       getElementById binds one element. There are two "Your booking" controls with
       that same id — the header pill and the cart bubble — so whichever came second
       kept its default behaviour and navigated straight to /cart, skipping the drawer
       entirely. That is the "clicking Your booking goes to the cart page" report.

       Delegation also survives the header being re-rendered by the theme editor. */
    document.addEventListener('click', function (e) {
        /* .mm-booking is the whole "Your booking" button. It has to be in this list
           because the id sits on the COUNT SPAN inside it, not on the button:

             <a class="mm-booking" href="/cart">      <- what you actually click
               [bag icon]
               <span class="mm-booking__label">Your booking</span>
               <span id="pb-cart-drawer-toggle" ...>2</span>   <- where the id is

           Matching the id alone meant closest() only found a toggle when the click
           landed on the two-digit number. Anywhere else on the button — the label, the
           icon, the padding — walked up to the <a> and navigated to /cart. */
        const toggle = e.target.closest('#pb-cart-drawer-toggle, [data-cart-drawer-toggle], .mm-booking');
        if (!toggle) return;

        e.preventDefault();

        const liveDrawer = document.querySelector('.pb-cart-drawer');
        if (!liveDrawer) return;   // no drawer on this page — let the link work

        liveDrawer.classList.contains('is-active')
            ? closeCartDrawer()
            : (pcdSuppress = false, openCartDrawer());
    });

    /* The shell renders its content inline for first paint, so the address field
       exists before any fetch has happened. Wire it now; wire() marks the block it has
       handled, so the re-render path calling it again is harmless. */
    pcdWireDelivery(drawer);

    /* Same refusal as the re-render path, for the inline first paint. */
    drawer.querySelector('.pb-cart-drawer-booking-btn.is-disabled')
        ?.addEventListener('click', function (ev) { ev.preventDefault(); });

    // ── Reposition on resize ───────────────────────────────
    window.addEventListener('resize', pcdPosition);
}

/* ── #137: the drawer did not reprice when the booking changed ────────────────
   Dates or location changed in the bar and the drawer kept whatever it rendered when
   it was last opened — stale prices, a stale range, a stale location, and no sign
   anything was wrong. Worse than a spinner: a wrong price that looks settled is a
   price the customer believes.

   Two events, both already fired by booking-bar.js: 'bookingbar:changed' on a date or
   location pick, and on clear at :645; 'pbcart:updated' for everything else touching
   the cart. booking-row.js fires the second as well, so a quantity change on the cart
   page also refreshes an open drawer.

   Only refreshes while OPEN. Closed, there is nothing on screen to correct, and
   openCartDrawer fetches the section every time — so the next open is fresh by
   construction rather than by bookkeeping. */
/*  dev-build 402 (Ben 12-10-2026): changing a quantity or removing a line re-renders
    the drawer, which threw the gear list back to the top. Every swap now keeps the
    list's scroll position (clamped, so removing the last rows can't leave it past the end). */
function pcdKeepScroll(host, fn) {
    var b = host && host.querySelector('.pb-cart-drawer-body'), y = b ? b.scrollTop : 0;
    fn();
    var nb = host && host.querySelector('.pb-cart-drawer-body');
    if (nb && y) { nb.scrollTop = Math.min(y, nb.scrollHeight - nb.clientHeight); requestAnimationFrame(function () { nb.scrollTop = Math.min(y, nb.scrollHeight - nb.clientHeight); }); }
}

let pcdRefreshing = false;

/*  527: a ready-made copy of the drawer, prepared in the background after every cart
    change (here or in another tab) and once the page has settled. Used on open only
    if nothing has changed since it was made (cartStore.version). */
let pcdWarm = { html: null, v: -1 };
let pcdShownV = -1;
let pcdWaitSince = 0, pcdWaitTimer = null;
function pcdVersion() { return (window.cartStore && window.cartStore.version) || 0; }
let pcdWarmTimer = null;
function pcdPrepare() {
    clearTimeout(pcdWarmTimer);
    pcdWarmTimer = setTimeout(function () {
        /* 532: while the drawer is open its own refresh fetches this same HTML (and keeps
           it as the ready copy), so a second background copy is skipped. */
        const dr = document.querySelector('.pb-cart-drawer');
        if (dr && dr.classList.contains('is-active')) return;
        const v = pcdVersion();
        fetch('/?section_id=pb-cart-drawer-body').then(r => r.ok ? r.text() : null).then(function (html) {
            if (html && v === pcdVersion()) pcdWarm = { html: html, v: v };
        }).catch(() => {});
    }, 600);
}
document.addEventListener('djw:cart', pcdPrepare);
window.addEventListener('load', function () { setTimeout(pcdPrepare, 1500); });
/*  529: changing a quantity or removing a line in the drawer skeletoned the row at once
    but the Hire total only a second later, when the drawer refresh started. The whole
    drawer now goes into its re-pricing state on the tap; the refresh clears it. */
document.addEventListener('click', function (e) {
    const b = e.target.closest && e.target.closest('.pb-cart-drawer .bc-detail-body-gear-item-qty-plus, .pb-cart-drawer .bc-detail-body-gear-item-qty-min, .pb-cart-drawer .bc-detail-body-gear-item-remove');
    if (!b || b.disabled || b.classList.contains('is-disabled')) return;
    const dr = b.closest('.pb-cart-drawer'); if (dr) dr.classList.add('is-repricing');
    clearTimeout(pcdRepriceGuard); pcdRepriceGuard = setTimeout(function () { dr && dr.classList.remove('is-repricing'); }, 6000);
}, true);
let pcdRepriceGuard = null;

async function refreshCartDrawerIfOpen() {
    const drawer = document.querySelector('.pb-cart-drawer');
    if (!drawer || !drawer.classList.contains('is-active')) return;
    if (pcdRefreshing) return;
    if (document.documentElement.classList.contains('djw-cart-busy')) return;
    /*  537: other parts of the page (the hire-length check, the item rows) ask for a
        refresh again after the change has settled. If the drawer already shows this
        version of the cart, there is nothing to redraw, so no second skeleton blink. */
    if (pcdShownV === pcdVersion() && !drawer.classList.contains('is-repricing')) return;
    pcdRefreshing = true;

    /*  Skeletons over the fields a booking change can move, and only those. Titles,
        option chips and images do not change, so covering the whole panel would flash
        content that was never going to move — which reads as a reload. */
    drawer.classList.add('is-repricing');

    /*  ── HELD FOR A MINIMUM, SO IT IS ACTUALLY SEEN ──────────────────────────
        The skeleton was correct and invisible: the section render returns in well
        under 100ms on a warm cache, so the class went on and off inside a single
        frame and Ben reported fields "not skeletoning" that were.

        A flash nobody perceives is worse than no skeleton at all, because the price
        then changes with no signal that anything was recalculated. 320ms is long
        enough to register as a state and short enough not to feel like waiting. */
    const started = Date.now();

    /*  538: don't draw a cart whose lines haven't been moved to the new hire length yet
        — keep the skeleton, the re-price that follows will refresh again. Gives up
        waiting after 8s so a product with no matching option can never hang it. */
    if (window.cartStore && window.cartStore.consistent) {
        const c = await fetch('/cart.js').then(r => r.json()).catch(() => null);
        if (c && !window.cartStore.consistent(c)) {
            if (!pcdWaitSince) pcdWaitSince = Date.now();
            if (Date.now() - pcdWaitSince < 8000) { pcdRefreshing = false; clearTimeout(pcdWaitTimer); pcdWaitTimer = setTimeout(pcdQueueRefresh, 1500); return; }
        }
        pcdWaitSince = 0;
    }

    const html = (pcdWarm.html && pcdWarm.v === pcdVersion()) ? pcdWarm.html : await fetch('/?section_id=pb-cart-drawer-body')
        .then(r => r.ok ? r.text() : null)
        .catch(() => null);
    if (html) pcdWarm = { html: html, v: pcdVersion() };

    const elapsed = Date.now() - started;
    if (elapsed < 320) {
        await new Promise(res => setTimeout(res, 320 - elapsed));
    }

    const host = drawer.querySelector('[data-drawer-content]');
    if (html && host) {
        pcdKeepScroll(host, function () { host.innerHTML = html; });
        /*  dev-build 206 — real availability on every row (DJWBlackout.markDrawer). */
        if (window.DJWBlackout && window.DJWBlackout.markDrawer) window.DJWBlackout.markDrawer(host);
        host.querySelector('.pb-cart-drawer-browsing-btn')
            ?.addEventListener('click', closeCartDrawer);
        host.querySelector('.pb-cart-drawer-booking-btn.is-disabled')
            ?.addEventListener('click', function (ev) { ev.preventDefault(); });
        pcdWireDelivery(drawer);
    }

    /*  543: a change that started while this refresh was fetching makes its result stale. */
    if (document.documentElement.classList.contains('djw-cart-busy')) { pcdRefreshing = false; pcdHoldSkeleton(); return; }
    if (html) pcdShownV = pcdVersion();
    drawer.classList.remove('is-repricing');
    pcdRefreshing = false;
}

/*  Debounced. Picking a range fires on the first date and again on the second, and a
    clear fires both events at once — so an undebounced listener would fetch the
    section three times for one customer action. */
let pcdRefreshTimer = null;
/*  574: a skeleton that's waiting for "the change has finished" can never wait for ever.
    Every place that holds the skeleton for a change still in progress arms this: once
    no change is running, the drawer is redrawn from the real cart. Before, if the
    finished signal never reached the drawer, the skeleton stayed until a reload. */
let pcdStuckT = null;
function pcdHoldSkeleton() {
    clearTimeout(pcdStuckT);
    pcdStuckT = setTimeout(function check() {
        const dr = document.querySelector('.pb-cart-drawer');
        if (!dr || !dr.classList.contains('is-repricing')) return;
        if (document.documentElement.classList.contains('djw-cart-busy') || pcdRefreshing) { pcdStuckT = setTimeout(check, 1500); return; }
        pcdShownV = -1; pcdQueueRefresh();
    }, 2500);
}
function pcdQueueRefresh() {
    clearTimeout(pcdRefreshTimer);
    pcdRefreshTimer = setTimeout(refreshCartDrawerIfOpen, 180);
}

/*  533: refresh when the cart has actually changed (djw:cart, after the save finishes),
    not when the dates are picked — that refresh showed the old prices and then ran again. */
/*  545: the re-price's last request brings the drawer back already drawn; it becomes the
    ready copy for this cart version, so the refresh below uses it instead of fetching. */
document.addEventListener('djw:cart', function () {
    if (window.__djwNextDrawerHtml) { pcdWarm = { html: window.__djwNextDrawerHtml, v: pcdVersion() }; window.__djwNextDrawerHtml = null; }
});
document.addEventListener('djw:cart', pcdQueueRefresh);
/*  536: the whole open drawer goes into its skeleton as soon as a cart change starts,
    and stays there until the single refresh after the last write. */
document.addEventListener('djw:cart-busy', function () {
    const dr = document.querySelector('.pb-cart-drawer');
    if (dr && dr.classList.contains('is-active') && !dr.classList.contains('is-repricing')) dr.classList.add('is-repricing');
    if (dr && dr.classList.contains('is-active')) pcdHoldSkeleton();
});
/*  540: anything else that would redraw part of the open drawer mid-change (the nights
    writer, the availability check) is held back while the cart is busy; the one refresh
    at the end draws it all. */
/*  542: the 540 class watcher is removed. Adding a class always records a change, even
    when it's already there, and another watcher answers drawer class changes by
    rewriting <html>'s class — the two fed each other forever and froze the page. The
    busy skeleton is now pure CSS (html.djw-cart-busy), so nothing needs to watch. */
document.addEventListener('pbcart:updated', pcdQueueRefresh);
/*  dev-build 291: a Remove pressed IN the drawer goes through booking-row.js, which
    announces 'bookingrow:updated' when the cart has changed. The drawer was only
    listening for the cart page's 'pbcart:updated', so the removed row stayed until the
    next open. Same debounced refresh. */
document.addEventListener('bookingrow:updated', pcdQueueRefresh);

document.addEventListener('DOMContentLoaded', initCartDrawer);

// ── Expose for pp-product.js ───────────────────────────────
window.showCartDrawer  = showCartDrawer;
window.openCartDrawer  = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;

/*  dev-build 291 — line the drawer up under the header's "Your booking" button. The
    header has a centred width now, so the button is no longer 20px from the window's
    edge. Its right edge is measured into --pb-drawer-right (used above 600px by
    pb-cart-drawer.css); re-measured on resize. Falls back to 20px. */
(function () {
  function measure() {
    var b = document.querySelector('.mm-booking');
    if (!b || !b.offsetParent) return;
    var r = Math.max(12, Math.round(window.innerWidth - b.getBoundingClientRect().right));
    document.documentElement.style.setProperty('--pb-drawer-right', r + 'px');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measure); else measure();
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
})();


/*  FULFIL FOLD — dev-build 293. "How you'll get it" starts folded; the toggle opens it.
    The drawer's content is replaced on every refresh, so the choice lives here for the
    visit (sessionStorage) and is re-applied whenever the content changes. */
(function () {
  var KEY = 'pcdFulfilOpen';
  function isOpen() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function apply(root) {
    (root || document).querySelectorAll('.pb-cart-drawer-fulfil').forEach(function (f) {
      var on = isOpen();
      f.classList.toggle('is-open', on);
      var b = f.querySelector('[data-pcd-fulfil-toggle]'); if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-pcd-fulfil-toggle]') : null; if (!t) return;
    try { sessionStorage.setItem(KEY, isOpen() ? '0' : '1'); } catch (er) {}
    apply();
  });
  function start() {
    apply();
    var host = document.querySelector('.pb-cart-drawer [data-drawer-content]');
    if (host) new MutationObserver(function () { apply(host); }).observe(host, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();


/* dev-build 297: the circled × in the drawer's header (phones). */
document.addEventListener('click', function (e) {
    var x = e.target.closest ? e.target.closest('[data-pcd-close]') : null;
    if (x) { e.preventDefault(); closeCartDrawer(); }
});


/*  dev-build 306 — tap-through from the chat window. On phones Front's chat fills the
    screen; tapping its close chevron shrinks the chat frame on the touch itself, so the
    browser's follow-up click lands on whatever was underneath (the header's "Your
    booking" button) and opened the cart drawer. When the frame shrinks from large to
    small, clicks are swallowed for half a second. Watches the frame's size, so it works
    however the chat is closed; does nothing while the chat is closed. */
(function () {
  var until = 0, big = false;
  function watch(f) {
    if (!window.ResizeObserver || f.__djwWatched) return;
    f.__djwWatched = true;
    new ResizeObserver(function () {
      var nowBig = f.offsetHeight > 300 && f.offsetWidth > 280;
      if (big && !nowBig) until = Date.now() + 500;
      big = nowBig;
    }).observe(f);
  }
  function find() { var f = document.getElementById('front-chat-iframe'); if (f) watch(f); return !!f; }
  if (!find()) {
    var mo = new MutationObserver(function () { if (find()) mo.disconnect(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
  ['click', 'pointerup', 'touchend'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (Date.now() < until) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); }
    }, true);
  });
})();

/*  ═══════════════════════════════════════════════════════════════════════════
    dev-build 462 — SAVE OR SHARE A BOOKING (Ben 15-10-2026, Share Booking.dc.html)
    One module for the cart (1a / 1b) and the drawer (1c), loaded with the drawer so it is
    on every page. The link packs the whole cart (lines with their options, booking
    attributes, note) into /cart?booking=. Opening it rebuilds that cart on the device
    (replacing any cart there) and lands on the cart page, so availability is checked
    fresh and every checkout tick still applies.
    "Email" posts to Web3Forms (Shared bookings form). Its autoresponder sends the
    recipient an email from DJ Warehouse with a copy of the submission, which carries the
    link; the team gets the notification as a log. If the send fails, the person's own
    email app opens instead. A hidden botcheck box and a 5-per-visit cap limit misuse.
    ═══════════════════════════════════════════════════════════════════════════ */
(function () {
    function enc(o) { return btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
    function dec(s) { s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '='; return JSON.parse(decodeURIComponent(escape(atob(s)))); }
    /*  476: shorter links. The booking is compressed (deflate) before encoding and goes in
        ?b=z…; roughly a third of the old length. Old ?booking= links still open. Browsers
        without CompressionStream fall back to the uncompressed form. */
    var SKIP = /^(Location|Location suburb|Charged nights|Pick up|Pick up time|Return|Return time|_pick_up_iso|_return_iso|_times_confirmed|Delivery distance km|Delivery estimate|_delivery_measured_from|_booking_link)$|terms/i;
    function b64u(bytes) { var s = ''; for (var i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]); return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
    function unb64u(s) { s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '='; var b = atob(s), u = new Uint8Array(b.length); for (var i = 0; i < b.length; i++) u[i] = b.charCodeAt(i); return u; }
    function encZ(o) {
        if (typeof CompressionStream === 'undefined') return Promise.resolve(enc(o));
        var st = new Blob([JSON.stringify(o)]).stream().pipeThrough(new CompressionStream('deflate-raw'));
        return new Response(st).arrayBuffer().then(function (ab) { return 'z' + b64u(new Uint8Array(ab)); });
    }
    function whenBuilder() {
        return new Promise(function (res) { var t = Date.now(); (function w() { if (typeof window.buildBookingAttributes === 'function' && window.locationMetaobjects) return res(); if (Date.now() - t > 5000) return res(); setTimeout(w, 50); })(); });
    }
    function decAny(s) {
        if (s.charAt(0) !== 'z') return Promise.resolve(dec(s));
        var st = new Blob([unb64u(s.slice(1))]).stream().pipeThrough(new DecompressionStream('deflate-raw'));
        return new Response(st).text().then(JSON.parse);
    }
    function post(u, b) { return fetch(u, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) }).then(function (r) { if (!r.ok) throw new Error(u + ' ' + r.status); return r.json(); }); }

    var qp = new URLSearchParams(location.search), q = qp.get('b') || qp.get('booking');
    if (q && /\/cart\/?$/.test(location.pathname)) {
        var veil = document.createElement('div');
        veil.className = 'bc-share-veil';
        veil.innerHTML = '<span><span class="bc-share-veil__spin" aria-hidden="true"></span>Loading the booking…</span>';
        document.documentElement.appendChild(veil);
        var say = function (t) { veil.querySelector('span').lastChild.textContent = t; };
        var bad = function () { say('That booking link is incomplete. Ask for it to be sent again.'); setTimeout(function () { location.replace('/cart'); }, 2500); };
        var data, attrs;
        Promise.resolve().then(function () { return decAny(q); }).then(function (d) {
            if (!d || !Array.isArray(d.i)) throw new Error('bad');
            /*  477 links: items are [variant36, qty, props?]; the booking is l/s/e and is
                rebuilt with the booking bar's own builder, so times and nights are today's.
                Older links (objects with v/q/p and full attributes) still open. */
            d.i = d.i.map(function (l) { return Array.isArray(l) ? { v: parseInt(l[0], 36), q: l[1], p: l[2] } : l; });
            data = d; attrs = Object.assign({}, data.a || {});
            if (d.l && d.s && d.e) return whenBuilder().then(function () {
                var loc = Object.values(window.locationMetaobjects || {}).find(function (x) { return (x.name || '') === d.l; });
                if (loc && typeof window.buildBookingAttributes === 'function') Object.assign(attrs, window.buildBookingAttributes(d.s, d.e, loc));
                else Object.assign(attrs, { 'Location': d.l, '_pick_up_iso': d.s, '_return_iso': d.e });
            });
        }).then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); }, function () { bad(); throw 'stop'; })
        .then(function (r) { return r.json(); }).then(function (c) {
            Object.keys(c.attributes || {}).forEach(function (k) { if (!(k in attrs)) attrs[k] = ''; });
            return post('/cart/clear.js', {});
        }).then(function () {
            return post('/cart/add.js', { items: data.i.map(function (l) { return { id: l.v, quantity: l.q, properties: l.p || {} }; }) });
        }).then(function () {
            return post('/cart/update.js', { attributes: attrs, note: data.n || '' });
        }).then(function () {
            try { sessionStorage.setItem('djwSharedBooking', '1'); } catch (e) {}
            location.replace('/cart');
        }).catch(function (err) {
            if (err === 'stop') return;
            say('Some of that booking could not be loaded, so it may be incomplete. Check the cart before you check out.');
            setTimeout(function () { location.replace('/cart'); }, 3000);
        });
        return;
    }

    /* After a shared link has rebuilt the cart: one line at the top of the cart page. */
    try {
        if (sessionStorage.getItem('djwSharedBooking') === '1' && /\/cart\/?$/.test(location.pathname)) {
            sessionStorage.removeItem('djwSharedBooking');
            document.addEventListener('DOMContentLoaded', function () {
                var h = document.querySelector('.bc-detail-top-header'); if (!h) return;
                var n = document.createElement('p'); n.className = 'bc-share-note';
                n.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7"/><path d="M12 3v12M8 7l4-4 4 4"/></svg><span></span>';
                n.querySelector('span').textContent = 'You\u2019ve opened a shared booking. Check the details, make any changes and check out when you\u2019re ready.';
                h.appendChild(n);
            });
        }
    } catch (e) {}

    function link() {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
            /*  477: the link carries only what the customer chose. Times, nights, labels,
                the delivery price and the terms tick are worked out again (or ticked again)
                when it opens, so a link shared before an hours change or a blackout can
                never carry stale times. */
            var at = c.attributes || {}, a = {};
            Object.keys(at).forEach(function (k) { if (at[k] !== '' && at[k] != null && !SKIP.test(k)) a[k] = at[k]; });
            var o = { i: c.items.map(function (it) { var r = [it.variant_id.toString(36), it.quantity]; if (it.properties && Object.keys(it.properties).length) r.push(it.properties); return r; }) };
            if (at['Location']) o.l = at['Location'];
            if (at['_pick_up_iso']) o.s = at['_pick_up_iso'];
            if (at['_return_iso']) o.e = at['_return_iso'];
            if (Object.keys(a).length) o.a = a;
            if (c.note) o.n = c.note;
            return encZ(o).then(function (s) { return { url: location.origin + '/cart?b=' + s, cart: c }; });
        });
    }
    /*  654 (#247): save the booking link to the cart once, as hidden _booking_link, just
        before checkout, so Flow can copy it onto the order. Hooks the cart form's submit
        (fires however the button is pressed) and drawer checkout links. 1.5s cap. */
    (function () {
        window.__djwBookingLinkHook = 654;
        function save() {
            return Promise.race([
                link().then(function (r) { return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _booking_link: r.url } }) }); }),
                new Promise(function (res) { setTimeout(res, 1500); })
            ]).catch(function () {});
        }
        document.addEventListener('submit', function (e) {
            var f = e.target; if (!f || f.__djwLinked || !f.querySelector('[name="checkout"]')) return;
            e.preventDefault(); f.__djwLinked = true;
            save().then(function () { HTMLFormElement.prototype.submit.call(f); });
        }, true);
        document.addEventListener('click', function (e) {
            var a = e.target.closest && e.target.closest('a[href*="/checkout"]'); if (!a || a.__djwLinked) return;
            e.preventDefault(); e.stopImmediatePropagation(); a.__djwLinked = true;
            save().then(function () { location.href = a.href; });
        }, true);
    })();
    /*  475 (Ben 15-10-2026): emailing a booking is parked (Task List, Post-Launch). Only Copy link remains; the Web3Forms send code is removed. */
    function closeAll(except) { document.querySelectorAll('[data-bc-share-pop]').forEach(function (p) { if (p !== except) { p.hidden = true; p.parentNode.classList.remove('is-emailing'); var b = p.parentNode.querySelector('[data-bc-share-menu]'); if (b) b.setAttribute('aria-expanded', 'false'); } }); }

    document.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target : null; if (!t) return;
        var box = t.closest('[data-bc-share]');
        if (!box) { closeAll(); return; }
        var menu = t.closest('[data-bc-share-menu]');
        if (menu) { e.preventDefault(); var pop = box.querySelector('[data-bc-share-pop]'); var open = pop.hidden; closeAll(pop); pop.hidden = !open; menu.setAttribute('aria-expanded', String(open)); box.classList.remove('is-emailing'); return; }
        if (t.closest('[data-bc-share-cancel]')) { e.preventDefault(); box.classList.remove('is-emailing'); return; }
        var cp = t.closest('[data-bc-share-copy]');
        if (cp) {
            e.preventDefault();
            link().then(function (r) {
                var done = function () { var l = cp.querySelector('[data-bc-share-copy-label]'); if (l) { var was = l.getAttribute('data-was') || l.textContent; l.setAttribute('data-was', was); l.textContent = 'Link copied'; setTimeout(function () { l.textContent = was; }, 2000); } };
                if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(r.url).then(done, function () { window.prompt('Copy this link', r.url); });
                else window.prompt('Copy this link', r.url);
            });
        }
    });

})();

/* 625: the branch beside "Your booking" ends exactly in line with the details card's right
   edge. The scrollbar and padding change, so it's measured. Only the branch's margin is
   written; the observer watches child lists, never styles, so it can't feed itself. */
(function () {
  function align() {
    var b = document.querySelector('.pb-cart-drawer .pb-cart-drawer-branch'),
        c = document.querySelector('.pb-cart-drawer .d6-card');
    if (!b || !c || !c.offsetWidth) return;
    b.style.marginRight = '0px';
    /* 627: on phones the circled × takes the right edge, so the branch stays left of it. */
    var x = document.querySelector('.pb-cart-drawer .pb-cart-drawer-x');
    if (x && x.offsetWidth) return;
    var d = b.getBoundingClientRect().right - c.getBoundingClientRect().right;
    if (Math.abs(d) > 0.5) b.style.marginRight = d + 'px';
  }
  var q = 0; function soon() { cancelAnimationFrame(q); q = requestAnimationFrame(align); }
  function boot() {
    var dr = document.querySelector('.pb-cart-drawer'); if (!dr) return;
    new MutationObserver(soon).observe(dr, { childList: true, subtree: true });
    window.addEventListener('resize', soon);
    document.addEventListener('transitionend', function (e) { if (dr.contains(e.target)) soon(); });
    soon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
